import React, { Component } from 'react';
import { history } from '../../helpers/history';
import SaayaLogo from '../../static/images/saaya-logo-new.png';

class TermsandCondition extends Component {
	redirectToHome() {
		history.replace('/home');
	}

	render() {

		const shouldHideButton = window.location.hostname === 'saayaeap.saayahealth.com';

		return (
			<div>
				<div className="container  w-100">
					<div className="text-center">
						<img
							className="logo confirm-logo"
							src={SaayaLogo}
							alt="SaayaHealth logo"
						/>

						<div className="p-5">
							<u>
								<h5 className="display-5">Agreement between Saaya Health and User</h5>
							</u>
						</div>
					</div>

					<div>
						<p style={{ textAlign: 'left' }}>
							Please read through the following terms and conditions. Once you have accepted the terms and
							conditions you can register and start using Saaya Health’s online portal for mental health
							and wellbeing.
						</p>

						<div>
							<p style={{ textDecoration: 'underline' }}>Counsellors</p>
							<p>
								Saaya Health will appoint a qualified Counsellor to you who will conduct live video
								Counselling Sessions.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Emergencies</p>
							<p>
								Saaya Health’s Counsellor will not attend to emergencies through this platform. In case
								of emergenciesplease visit one of these facilities immediately .
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Confidentiality</p>
							<p>
								Everything that is discussed in Saaya Health’s Counselling Sessions is kept confidential
								except in the following cases:
							</p>
							<ul>
								<li>Where there is a risk that the user might be harmed</li>
								<li>Where there is a risk that another person might be harmed</li>
								<li>
									For the purpose of supervision. Supervision sessions allow Counsellors to gain
									support andguidance in their work and also check that they are working ethically and
									competently. Everythingthat is discussed in a supervision session is kept
									confidential by the Counsellor and its supervisor
								</li>
							</ul>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Timing</p>
							<p>
								While the user may specify the preferred appointment timing for a Counselling Session,
								Saaya Healthreserves the right to schedule the appointment for an alternative timing. If
								this timing is not convenient,the user can request that it be rescheduled.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Frequency</p>
							<p>
								The frequency of Counselling Sessions are usually mutually decided by the Counsellor and
								User.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Duration</p>
							<p>The duration of a Counselling Session is usually not more than one hour.</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Privacy, Security & Etiquette:</p>
							<p>
								It is required that the patient prepares ahead of time to participate in the Counselling
								Session, in a quietand private place, where only the patient is present in the room
								where the video session is being held. Fordisabled patients who require help to
								participate in the video, a caregiver may be present. T​here must beno audio/video
								recording of the video session by the patient.It is necessary that the patient (and any
								caregiver) act with proper decorum in speech and action duringthe video consultation.
								Failure to comply with these requirements can result in termination of the videosession
								with no refund or rescheduling of the consultation.
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Rescheduling:</p>
							<p>
								Due to unpredictable medical emergencies, it may be that the Counsellor is sometimes
								unable to attendto the Counselling Session exactly at the appointed time. In such cases
								the Counselling Session might berescheduled to a later time in consultation with the
								User.If the healthcare provider has to be conclude the video consultation mid-way due to
								a medical emergency,then a new session at an alternative timing may be scheduled. Being
								an online application, there might be unforeseeable network and infrastructure issues in
								which casethe application will not be available until the issue is rectified. In such
								cases the Counselling Sessionmight be rescheduled to a later time in consultation with
								the User
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Data</p>
							<p>
								The User’s data will be kept confidential by Saaya Health and will not be disclosed to
								anyone undernormal circumstances except as requested by law or in an emergency situation
								when requested byanother healthcare provider.We may disclose your personal information
								on your own request accompanied by your permission.
							</p>
						</div>
						<div>
							<p style={{ textDecoration: 'underline' }}>Payments</p>
							<p>
								Counselling Sessions conducted on Saaya Health will be paid for by respective organizations unless specified
								otherwise.
							</p>
							<b>I agree to the following:</b>
							<ul>
								<li>
									The personal information I have provided during the registration process is true,
									accurate, currentand complete.
								</li>
								<li>
									My username and password are unique to me, and I agree not to disclose or share my
									usernameand password to or with any third party. I am responsible for keeping my
									password confidentialand for notifying Saaya Health immediately if my password has
									been hacked or stolen.
								</li>
								<li>
									I agree to receive service related notifications in the form of SMS, email or mobile
									notifications from Saaya Health
								</li>
								<li>
									I will not use any service or information in this application for any purposes other
									than managingmy personal health and wellbeing and/or to engage with Saaya Health’s
									Counsellors
								</li>
								<li>
									As a User of Saaya Health, I am required to inform my Counsellor of all current and
									previousillnesses, health conditions, consultations and medications with any other
									healthcare providers.While my Counsellor may ask me for this information, it is my
									responsibility to update the Counsellor completely and correctly
								</li>
								<li>My contact information may also be used for customer support services.</li>
							</ul>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Signature:</p>
							<p>
								The above mentioned terms are applicable as long as you are a registered patient of
								SaayaHealth's Virtual Practice
							</p>
						</div>

						<div>
							<p style={{ textDecoration: 'underline' }}>Furhter Details:</p>
							<ul>
								<li>
									SaayaHealth is not liable for any periods of non-availability of this application.
								</li>
								<li>
									SaayaHealth reserves the right to deny or revoke access to any user account at its
									sole discretion.
								</li>
								<li>
									All engagement between your healthcare provider and you through this application are
									governedby these Patient Terms.
								</li>
								<li>
									SaayaHealth will make all possible efforts to provide you the best healthcare
									services. However,SaayaHealth shall not incur any liability and shall declare any
									service guarantee void in the eventthe user is in breach of any of the Terms and
									Conditions of this Agreement
								</li>
								<li>
									Both parties are at liberty to terminate this agreement. Terminating the agreement
									will cancel onlyyour continuance as patient of our Virtual Practice. It does not
									terminate nor impact any other consultations or patient-provider relationship that
									you have with SaayaHealth.
								</li>
								<li>
									SaayaHealth uses 3rd party OpenTok Apis for secure video connection between both
									parties
								</li>
								<li>
									All your personal health data and usage data is owned by SaayaHealth irrespective of
									the accessyou may or may not have to it. Your usage and access to your data is
									defined by SaayaHealth
								</li>
								<li>
									Non- personalised system analysis of non-identifiable patient data may be done to
									enable betterhealthcare outcomes for the patients of SaayaHealth. However the
									identity of individual users willremain completely anonymous in such analysis.
								</li>
								<li>
									Video Consultation Duration: By default the average duration of a Video Consultation
									will be the duration decided by the healthcare provider. SaayaHealth reserves the
									right to decide when the consultation ends. This could be earlier than the maximum
									possible duration.
								</li>
								<li>
									The personal and health information added through this application, through use of
									its services bypatients and healthcare providers of SaayaHealth will not be shared,
									disclosed or displayed toanyone other than authorized employees of SaayaHealth.
								</li>
								<li>
									SaayaHealth may analyze anonymized and aggregated collected through the services,
									forpurposes of evaluating healthcare outcomes, healthcare requirement patterns and
									to measurethe effectiveness of services and content
								</li>
								<li>
									Necessary measures in providing secure transmission of personal health information
									before it istransferred across the Internet from your personal computer or devices
									are ensured. However,you should be aware of possible risk involved in transmitting
									information over the Internet as nodata transmission can be guaranteed to be 100%
									secure and of risk that others could find a wayto thwart our security systems. As a
									result, while we strive to protect your personal information,we cannot ensure or
									warrant the security and privacy of personal information you transmit to us,and you
									do so at your own risk.Necessary measures in providing secure transmission of
									personal health information before it istransferred across the Internet from your
									personal computer or devices are ensured. However,you should be aware of possible
									risk involved in transmitting information over the Internet as nodata transmission
									can be guaranteed to be 100% secure and of risk that others could find a wayto
									thwart our security systems. As a result, while we strive to protect your personal
									information,we cannot ensure or warrant the security and privacy of personal
									information you transmit to us,and you do so at your own risk.
								</li>
								<li>
									Any user providing, storing or submitting information on behalf of a child/person
									underguardianship assumes full responsibility over the submission, use, and
									transmission of suchinformation.
								</li>
								<li>
									SaayaHealth is in no way responsible for any loss that you may incur as a result of
									any unauthorized use of your user account and password.
								</li>
								<li>
									Please note that this Privacy Policy may change from time to time as we continue to
									offer evolveour services.
								</li>
							</ul>
						</div>
					</div>
					{!shouldHideButton && (
						<div className="text-center mt-9 mb-5">
							<button className="btn  btn-primary  pl-5 pr-5 mb-0 custom-btn " onClick={this.redirectToHome}>
								Go To Home Page
							</button>
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default TermsandCondition;



// WEBPACK FOOTER //
// ./src/components/Terms and Condition/index.js